module.exports = "/_next/static/images/3-10f604f6bf0a5077000b234218911ddc.png";